export const voteData = [
  {
    id: 1,
    title: 'House Vote Against Net Neutrality',
    date: '2011-04-08',
    href: 'https://clerk.house.gov/Votes/2011252',
    desc: 'Disapproving the rule submitted by the Federal Communications Commission with respect to regulating the Internet and broadband industry practices',
    bill: 'H.J.Res.37',
    congress: 112,
    votes: {
      demPro: 6,
      demCon: 177,
      repPro: 234,
      repCon: 2
    },
    backgroundLinks: [
      { title: 'wired.com', href: 'https://www.wired.com/2011/04/house-net-neutrality-vote/' },
      { title: 'variety.com', href: 'https://variety.com/2011/biz/opinion/house-votes-to-rollback-net-neutrality-rules-37857/' }
    ],
    tags: ['internet', 'net neutrality', 'fcc', 'house']
  },
  {
    id: 2,
    title: 'Senate Vote Against Net Neutrality',
    date: '2011-11-10',
    href: 'https://www.govtrack.us/congress/votes/112-2011/s200',
    desc: 'A joint resolution disapproving the rule submitted by the Federal Communications Commission with respect to regulating the Internet and broadband industry practices',
    bill: 'S.J.Res.6',
    congress: 112,
    votes: {
      demPro: 0,
      demCon: 50,
      repPro: 46,
      repCon: 0
    },
    backgroundLinks: [
      { title: 'washingtonpost.com', href: 'https://www.washingtonpost.com/blogs/post-tech/post/senate-votes-against-net-neutrality-killer/2011/11/10/gIQAdScC9M_blog.html' },
      { title: 'arstechnica.com', href: 'https://arstechnica.com/tech-policy/2011/11/senate-votes-down-anti-net-neutrality-resolution/' }
    ],
    tags: ['internet', 'net neutrality', 'fcc', 'senate']
  },
  {
    id: 3,
    title: 'Campaign Finance Disclosure Requirements',
    date: '2010-09-23',
    href: 'https://justfacts.votesmart.org/bill/votes/32154',
    desc: 'Relates to the DISCLOSE Act',
    bill: 'S.3628',
    congress: 111,
    votes: {
      demPro: 57,
      demCon: 0,
      repPro: 0,
      repCon: 39
    },
    backgroundLinks: [
      { title: 'wikipedia.org', href: 'https://en.wikipedia.org/wiki/DISCLOSE_Act' }
    ],
    tags: ['campaign finance', 'voting', 'elections', 'senate']
  },
  {
    id: 4,
    title: 'DISCLOSE Act',
    date: '2012-07-17',
    href: 'https://justfacts.votesmart.org/bill/votes/41152',
    desc: 'Relates to the DISCLOSE Act',
    bill: 'S.3369',
    congresss: 112,
    votes: {  
      demPro: 51,
      demCon: 0,
      repPro: 0,
      repCon: 45
    },
    backgroundLinks: [
      { title: 'wikipedia.org', href: 'https://en.wikipedia.org/wiki/DISCLOSE_Act' }
    ],
    tags: ['campaign finance', 'voting', 'elections', 'senate']
  },
  {
    id: 5,
    title: 'For The People Act',
    date: '2021-06-16',
    href: 'https://www.congress.gov/bill/117th-congress/senate-bill/2093',
    desc: 'This bill addresses voter access, election integrity and security, campaign finance, and ethics for the three branches of government.',
    bill: 'S.2093',
    congress: 117,
    votes: {
      demPro: 50,
      demCon: 0,
      repPro: 0,
      repCon: 50
    },
    backgroundLinks: [
      { title: 'wikipedia.org', href: 'https://en.wikipedia.org/wiki/For_the_People_Act' }
    ],
    tags: [ 'elections', 'voting', 'campaign finance', 'senate' ]
  },
  {
    id: 6,
    title: 'Backup Paper Ballots',
    date: '2008-07-15',
    href: 'https://www.congress.gov/bill/110th-congress/house-bill/5803/text',
    desc: 'This vote was taken during a suspension of the rules to cut off debate early and vote to pass the bill, thereby requiring a two-thirds majority for passage.  The bill thus failed.',
    bill: 'H.R.5803',
    congress: 110,
    votes: {
      demPro: 228,
      demCon: 0,
      repPro: 20,
      repCon: 170
    },
    backgroundLinks: [
      { title: 'govtrack.us', href: 'https://www.govtrack.us/congress/bills/110/hr5803' }
    ],
    tags: [ 'elections', 'voting', 'ballots', 'house' ]
  },
  {
    id: 7,
    title: 'Bipartisan Campaign Reform Act',
    date: '2002-02-14',
    href: 'https://www.congress.gov/bill/107th-congress/house-bill/2356',
    desc: 'Amended the Federal Election Campaign Act of 1971, which regulates the financing of political campaigns.',
    bill: 'H.R.2356',
    congress: 107,
    votes: {
      demPro: 198,
      demCon: 12,
      repPro: 41,
      repCon: 176
    },
    backgroundLinks: [
      { title: 'wikipedia.org', href: 'https://en.wikipedia.org/wiki/Bipartisan_Campaign_Reform_Act' }
    ],
    tags: [ 'elections', 'campaign finance', 'house' ]
  },
  {
    id: 8,
    title: 'Overturn Citizens United',
    date: '2014-09-11',
    href: 'https://www.congress.gov/bill/113th-congress/senate-joint-resolution/19/text',
    desc: 'Vote on a motion to invoke cloture on a joint resolution that submits a constitutional amendment to the States for ratification that amends campaign finance laws.  The amendment: Sets reasonable limits on the raising and spending of money by electoral candidates to influence elections.',
    bill: 'S.J.Res.19',
    congress: 113,
    votes: {
      demPro: 52,
      demCon: 0,
      repPro: 0,
      repCon: 42
    },
    backgroundLinks: [
      { title: 'wikipedia.org', href: 'https://en.wikipedia.org/wiki/Citizens_United_v._FEC' },
      { title: 'vox.com', href: 'https://www.vox.com/2014/9/11/6131163/citizens-united-constitutional-amendment-explained' }
    ],
    tags: [ 'elections', 'campaign finance', 'senate', 'citizens united' ]
  },
  {
    id: 9,
    title: 'Limits Interest Rates for Certain Federal Student Loans',
    date: '2013-07-04',
    href: 'https://www.congress.gov/amendment/113th-congress/senate-amendment/1778/text',
    desc: 'Vote to adopt an amendment to S Amdt 1773 to HR 1911 that limits interest rates for certain federal student loans',
    bill: 'S.Amdt.1778',
    congress: 113,
    votes: {
      demPro: 45,
      demCon: 6,
      repPro: 0,
      repCon: 46
    },
    backgroundLinks: [
      { title: 'votesmart.org', href: 'https://justfacts.votesmart.org/bill/votes/45797' }
    ],
    tags: [ 'student loans', 'education', 'finance' ]
  },
  {
    id: 10,
    title: 'Student Loan Affordability Act',
    date: '2013-06-06',
    href: 'https://www.congress.gov/bill/113th-congress/senate-bill/953/text',
    desc: 'Provides two further years of reduced interest rates for student loans, among other provisions',
    bill: 'S.953',
    congress: 113,
    votes: {
      demPro: 50,
      demCon: 1,
      repPro: 0,
      repCon: 44
    },
    backgroundLinks: [
      { title: 'votesmart.org', href: 'https://justfacts.votesmart.org/bill/16814/44550/student-loan-affordability-act' }
    ],
    tags: [ 'student loans', 'education', 'finance' ]
  },
  {
    id: 11,
    title: 'Low-Income Home Energy Assistance Funding Amendment',
    date: '2005-10-26',
    href: 'https://www.congress.gov/amendment/109th-congress/senate-amendment/2253/text',
    desc: 'Vote on an amendment that increases appropriations for the Low-Income Home Energy Assistance Program by $1.28 billion and decreases the amount of discretionary funds appropriated in all appropriation acts this year by .92 percent.',
    bill: 'S.Amdt.2253',
    congress: 109,
    votes: {
      demPro: 0,
      demCon: 43,
      repPro: 46,
      repCon: 8
    },
    backgroundLinks: [
      { title: 'votesmart.org', href: 'https://justfacts.votesmart.org/bill/votes/9034' }
    ],
    tags: [ 'energy', 'finance', 'incomes' ]
  },
  {
    id: 12,
    title: 'End the Bureau of Consumer Financial Protection',
    date: '2010-05-13',
    href: 'https://www.congress.gov/amendment/111th-congress/senate-amendment/3987/text',
    desc: 'Vote to adopt an amendment to S Amdt 3739 to S 3217 that terminates the Bureau of Consumer Financial Protection and its authority 4 years after the date of enactment, unless extended by an Act of Congress.',
    bill: 'S.Amdt.3987 to S.Amdt.3739',
    congress: 111,
    votes: {
      demPro: 1,
      demCon: 52,
      repPro: 39,
      repCon: 1
    },
    backgroundLinks: [
      { title: 'wikipedia.org', href: 'https://en.wikipedia.org/wiki/Consumer_Financial_Protection_Bureau' }
    ],
    tags: [ 'finance', 'consumer protection', 'economics' ]
  },
  {
    id: 13,
    title: 'Table (Refuse to Take Up) Credit Default Swap Regulations',
    date: '2010-05-18',
    href: 'https://www.congress.gov/amendment/111th-congress/senate-amendment/4114/text',
    desc: 'Vote on a motion to table an amendment to S Amdt 4072 to S 3217 that establishes new restrictions on activities related to credit default swaps, including prohibiting "naked" credit default swaps.',
    bill: 'S.Amdt.4114',
    congress: 111,
    votes: {
      demPro: 18,
      demCon: 35,
      repPro: 38,
      repCon: 18
    },
    backgroundLinks: [
      { title: 'dispatch.com', href: 'https://www.dispatch.com/story/news/2010/05/19/ban-on-credit-default-swaps/24208850007/' }
    ],
    tags: [ 'finance', 'economics', 'regulations' ]
  },
  {
    id: 14,
    title: 'Prevent Gas Price Gouging',
    date: '2022-05-19',
    href: 'https://www.congress.gov/bill/117th-congress/house-bill/7688',
    desc: 'This bill prohibits any person from selling, during a proclaimed energy emergency, a consumer fuel at a price that (1) is unconscionably excessive, and (2) indicates that the seller is exploiting the emergency to increase prices unreasonably. The President may issue a proclamation of such an emergency that specifies the consumer fuel and geographic area covered and how long the proclamation applies. The bill provides for enforcement of these provisions by the Federal Trade Commission and state attorneys general. Civil penalties collected by the commission through such enforcement must be used to provide assistance under the Low Income Home Energy Assistance Program.',
    bill: 'H.R.7688',
    congress: 117,
    votes: {
      demPro: 217,
      demCon: 4,
      repPro: 0,
      repCon: 203
    },
    backgroundLinks: [
      { title: 'govtrack.us', href: 'https://www.govtrack.us/congress/votes/117-2022/h232' },
      { title: 'reuters.com', href: 'https://www.reuters.com/business/energy/us-house-passes-bill-fight-oil-gas-price-gouging-2022-05-19/' },
      { title: 'pbs.org', href: 'https://www.pbs.org/newshour/economy/house-approves-bill-to-combat-gasoline-price-gouging' }
    ],
    tags: [ 'gas', 'economy', 'prices', 'inflation' ]
  },
  {
    id: 15,
    title: 'House Vote to Provide Supplemental Infant Formula',
    date: '2022-05-18',
    href: 'https://www.congress.gov/bill/117th-congress/house-bill/7790',
    desc: 'Making emergency supplemental appropriations to address the shortage of infant formula in the United States for the fiscal year ending September 30, 2022, and for other purposes.',
    bill: 'H.R.7790',
    congress: 117,
    votes: {
      demPro: 219,
      demCon: 0,
      repPro: 12,
      repCon: 192
    },
    backgroundLinks: [
      { title: 'govtrack.us', href: 'https://www.govtrack.us/congress/votes/117-2022/h220' },
      { title: 'washingtonpost.com', href: 'https://www.washingtonpost.com/politics/2022/05/19/republicans-baby-formula/' }
    ],
    tags: [ 'FDA', 'appropriations', 'child care' ]
  },
  {
    id: 16,
    title: 'House Vote on Domestic Terrorism Prevention Act of 2022',
    date: '2022-05-18',
    href: 'https://www.congress.gov/bill/117th-congress/house-bill/350',
    desc: 'This bill establishes new requirements to expand the availability of information on domestic terrorism, as well as the relationship between domestic terrorism and hate crimes. It authorizes domestic terrorism components within the Department of Homeland Security (DHS), the Department of Justice (DOJ), and the Federal Bureau of Investigation (FBI) to monitor, analyze, investigate, and prosecute domestic terrorism. The domestic terrorism components of DHS, DOJ, and the FBI must jointly report on domestic terrorism, including white-supremacist-related incidents or attempted incidents.',
    bill: 'H.R.350',
    congress: 117,
    votes: {
      demPro: 221,
      demCon: 0,
      repPro: 1,
      repCon: 203
    },
    backgroundLinks: [
      { title: 'govtrack.us', href: 'https://www.govtrack.us/congress/votes/117-2022/h221' }
    ],
    tags: [ 'terrorism', 'domistic terrorism', 'security', 'FBI', 'DHS', 'DOJ' ]
  },
  {
    id: 17,
    title: 'Senate Vote on Domestic Terrorism Prevention Act of 2022',
    date: '2022-05-18',
    href: 'https://www.govtrack.us/congress/votes/117-2022/s210',
    desc: 'This Senate vote effectively ended the opportunity to pass this bill. This bill establishes new requirements to expand the availability of information on domestic terrorism, as well as the relationship between domestic terrorism and hate crimes. It authorizes domestic terrorism components within the Department of Homeland Security (DHS), the Department of Justice (DOJ), and the Federal Bureau of Investigation (FBI) to monitor, analyze, investigate, and prosecute domestic terrorism. The domestic terrorism components of DHS, DOJ, and the FBI must jointly report on domestic terrorism, including white-supremacist-related incidents or attempted incidents.',
    bill: 'H.R.350',
    congress: 117,
    votes: {
      demPro: 45,
      demCon: 1,
      repPro: 0,
      repCon: 46
    },
    backgroundLinks: [
      { title: 'politico.com', href: 'https://www.politico.com/news/2022/05/26/senate-gop-domestic-terrorism-bill-00035240' },
      { title: 'thehill.com', href: 'https://thehill.com/news/senate/3502569-senate-republicans-block-domestic-terrorism-bill/' },
      { title: 'reuters.com', href: 'https://www.reuters.com/world/us/us-senate-republicans-poised-block-bill-aimed-domestic-terrorism-2022-05-26/' }
    ],
    tags: [ 'terrorism', 'domestic terrorism', 'security', 'FBI', 'DHS', 'DOJ' ]
  },

  {
    id: 18,
    title: 'Credit Default Swap Regulations',
    date: '2010-5-18',
    href: 'https://justfacts.votesmart.org/bill/votes/30364',
    desc: 'Vote on a motion to table an amendment to S Amdt 4072 to S 3217 that establishes new restrictions on activities related to credit default swaps, including prohibiting "naked" credit default swaps.',
    bill: 'S. Amdt. 4114',
    congress: 111,
    votes: {
      demPro: 18,
      demCon: 35,
      repPro: 38,
      repCon: 2
    },
    backgroundLinks: [
      { title: 'corporatefinanceinstitute.com', href: 'https://corporatefinanceinstitute.com/resources/knowledge/finance/credit-default-swap-cds/' },
      { title: 'congress.gov', href: 'https://www.congress.gov/amendment/111th-congress/senate-amendment/4114' }
    ],
    tags: [ 'credit default swaps', 'finance', 'economics', 'regulations' ]
  },
  {
    id: 19,
    title: 'Bring Jobs Home Act',
    date: '2014-06-30',
    href: 'https://justfacts.votesmart.org/bill/votes/49616',
    desc: 'Vote on a motion to invoke cloture on a bill that prohibits tax credits for outsourcing expenses and establishes a tax credit for insourcing expenses.',
    bill: 'H.R. 2341',
    congress: 117,
    votes: {
      demPro: 51,
      demCon: 1,
      repPro: 1,
      repCon: 41
    },
    backgroundLinks: [
      { title: 'govtrack.us', href: 'https://www.govtrack.us/congress/bills/117/hr2341' },
      { title: 'congress.gov', href: 'https://www.congress.gov/bill/117th-congress/house-bill/2341?r=1&s=2' }
    ],
    tags: [ 'jobs', 'tax credits', 'economy', 'trade' ]
  },
    {
    id: 20,
    title: 'House Vote on Disapproval of Presidents Authority to Raise the Debt Limit',
    date: '2012-01-18',
    href: 'https://justfacts.votesmart.org/bill/votes/37606',
    desc: 'Vote on a motion to proceed to consideration of a joint resolution that disapproves of the Presidents exercise of authority to increase the debt limit of the United States.',
    bill: 'H.J.Res.98',
    congress: 112,
    votes: {
      demPro: 6,
      demCon: 175,
      repPro: 233,
      repCon: 1
    },
    backgroundLinks: [
      { title: 'congress.gov', href: 'https://www.congress.gov/bill/112th-congress/house-joint-resolution/98?q=%7B%22search%22%3A%5B%22H+J+Res+98%22%2C%22H%22%2C%22J%22%2C%22Res%22%2C%2298%22%5D%7D&s=4&r=11' }
    ],
    tags: [ 'president', 'debt limit' ]
  },
      {
    id: 21,
    title: 'Senate Vote on Disapproval of Presidents Authority to Raise the Debt Limit',
    date: '2012-01-26',
    href: 'https://justfacts.votesmart.org/bill/votes/37876',
    desc: 'Vote on a motion to proceed to consideration of a joint resolution that disapproves of the Presidents exercise of authority to increase the debt limit of the United States.',
    bill: 'H.J.Res.98',
    congress: 112,
    votes: {
      demPro: 2,
      demCon: 49,
      repPro: 42,
      repCon: 1
    },
    backgroundLinks: [
      { title: 'congress.gov', href: 'https://www.congress.gov/bill/112th-congress/house-joint-resolution/98?q=%7B%22search%22%3A%5B%22H+J+Res+98%22%2C%22H%22%2C%22J%22%2C%22Res%22%2C%2298%22%5D%7D&s=4&r=11' }
    ],
    tags: [ 'president', 'debt limit' ]
  },
    {
    id: 22,
    title: 'Senate Vote on Lilly Ledbetter Fair Pay Act of 2009',
    date: '2009-01-22',
    href: 'https://justfacts.votesmart.org/bill/votes/23313',
    desc: 'Vote to pass a bill that redefines unlawful employment laws and counts each paycheck as an offense if a salary is ruled as discriminatory.',
    bill: 'S. 181',
    congress: 111,
    votes: {
      demPro: 55,
      demCon: 0,
      repPro: 4,
      repCon: 36
    },
    backgroundLinks: [
      { title: 'govtrack.us', href: 'https://www.govtrack.us/congress/bills/111/s181' },
      { title: 'congress.gov', href: 'https://www.congress.gov/bill/111th-congress/senate-bill/181' }
    ],
    tags: [ 'fair pay', 'jobs', 'economy', 'Lilly Ledbetter' ]
  },
     {
    id: 23,
    title: 'House Vote on Lilly Ledbetter Fair Pay Act of 2009',
    date: '2009-01-27',
    href: 'https://justfacts.votesmart.org/bill/votes/23361',
    desc: 'Vote to pass a bill that redefines unlawful employment laws and counts each paycheck as an offense if a salary is ruled as discriminatory.',
    bill: 'S. 181',
    congress: 111,
    votes: {
      demPro: 247,
      demCon: 4,
      repPro: 3,
      repCon: 173
    },
    backgroundLinks: [
       { title: 'govtrack.us', href: 'https://www.govtrack.us/congress/bills/111/s181' },
      { title: 'congress.gov', href: 'https://www.congress.gov/bill/111th-congress/senate-bill/181' }
    ],
    tags: [ 'fair pay', 'jobs', 'economy', 'Lilly Ledbetter' ]
  },
    {
    id: 24,
    title: 'Dodd-Frank Wall Street Reform and Consumer Protection Act',
    date: '2010-05-20',
    href: 'https://justfacts.votesmart.org/bill/votes/30346',
    desc: 'Passed in response to the 2008 global financial crisis, the Act brought the most significant changes to financial regulation in the nation since the regulatory reform that came following the Great Recession. It made changes in the American financial regulatory environment affecting all federal financial regulatory agencies and almost every part of the nations financial services industry.',
    bill: 'H.R. 4173',
    congress: 111,
    votes: {
      demPro: 53,
      demCon: 2,
      repPro: 4,
      repCon: 37
    },
    backgroundLinks: [
      { title: 'govtrack.us', href: 'https://www.govtrack.us/congress/bills/111/hr4173/summary' },
      { title: 'congress.gov', href: 'https://www.congress.gov/bill/111th-congress/house-bill/4173?q=%7B%22search%22%3A%5B%22HR+4173%22%2C%22HR%22%2C%224173%22%5D%7D&s=7&r=6' }
    ],
    tags: [ 'Dodd-Frank', 'wall street', 'reform', 'consumer protection', 'Great Recession', 'finance', 'economy' ]
  },
    {
    id: 25,
    title: 'American Jobs Act of 2011',
    date: '2011-10-11',
    href: 'https://justfacts.votesmart.org/bill/votes/36879',
    desc: 'A bill to provide tax relief for American workers and businesses, to put workers back on the job while rebuilding and modernizing America, and to provide pathways back to work for Americans looking for jobs.',
    bill: 'S. 1660',
    congress: 112,
    votes: {
      demPro: 48,
      demCon: 3,
      repPro: 0,
      repCon: 46
    },
    backgroundLinks: [
      { title: 'govtrack.us', href: 'https://www.govtrack.us/congress/bills/112/s1660' },
      { title: 'congress.gov', href: 'https://www.congress.gov/bill/112th-congress/senate-bill/1660?q=%7B%22search%22%3A%5B%22S+1660+-+American+Jobs+Act+of+2011%22%2C%22S%22%2C%221660%22%2C%22American%22%2C%22Jobs%22%2C%22Act%22%2C%22of%22%2C%222011%22%5D%7D&s=1&r=1' }
    ],
    tags: [ 'jobs', 'business', 'economy' ]
  },
      {
    id: 26,
    title: 'Emergency Unemployment Compensation Extension Act',
    date: '2014-1-14',
    href: 'https://justfacts.votesmart.org/bill/votes/46392',
    desc: 'Vote on a motion to invoke cloture on a bill that extends unemployment compensation benefits and services.',
    bill: 'S. 1845',
    congress: 113,
    votes: {
      demPro: 52,
      demCon: 1,
      repPro: 1,
      repCon: 44
    },
    backgroundLinks: [
      { title: 'govtrack.us', href: 'https://www.govtrack.us/congress/bills/113/s1845' },
      { title: 'congress.gov', href: 'https://www.congress.gov/bill/113th-congress/senate-bill/1845?q=%7B%22search%22%3A%5B%22S+1845+-+Emergency+Unemployment+Compensation+Extension+Act%22%2C%22S%22%2C%221845%22%2C%22Emergency%22%2C%22Unemployment%22%2C%22Compensation%22%2C%22Extension%22%2C%22Act%22%5D%7D&s=3&r=1' }
    ],
    tags: [ 'unemployment', 'jobs', 'economy' ]
  },
    {
    id: 27,
    title: 'Reduces Funding for Food Stamps',
    date: '2012-6-13',
    href: 'https://justfacts.votesmart.org/bill/votes/40315',
    desc: 'Repeals the federal supplemental nutrition assistance program, authorizes the Department of Agriculture to provide grants to states for supplemental nutrition assistance, and limits appropriations for the grant program to $45 billion per year.',
    bill: 'S. Amdt. 2392',
    congress: 112,
    votes: {
      demPro: 50,
      demCon: 0,
      repPro: 13,
      repCon: 33
    },
    backgroundLinks: [
      { title: 'politico.com', href: 'https://www.politico.com/story/2012/06/food-stamp-cuts-rejected-077391' },
      { title: 'congress.gov', href: 'https://www.congress.gov/amendment/112th-congress/senate-amendment/2392' }
    ],
    tags: [ 'funding', 'food stamps', 'welfare', 'Department of Agriculture' ]
  },
    {
    id: 28,
    title: 'Minimum Wage Fairness Act',
    date: '2014-4-30',
    href: 'https://justfacts.votesmart.org/bill/votes/47753',
    desc: 'Vote on a motion to invoke cloture on the motion to proceed to debate on a bill that increases the federal minimum wage to $10.10 an hour.',
    bill: 'S. 2223',
    congress: 113,
    votes: {
      demPro: 51,
      demCon: 1,
      repPro: 1,
      repCon: 41
    },
    backgroundLinks: [
      { title: 'govtrack.us', href: 'https://www.govtrack.us/congress/bills/113/s2223' },
      { title: 'congress.gov', href: 'https://www.congress.gov/bill/113th-congress/senate-bill/2223?q=%7B%22search%22%3A%5B%22S+2223+-+Minimum+Wage+Fairness+Act%22%2C%22S%22%2C%222223%22%2C%22Minimum%22%2C%22Wage%22%2C%22Fairness%22%2C%22Act%22%5D%7D&s=8&r=1' }
    ],
    tags: [ 'wage', 'minimum wage', 'jobs', 'economy' ]
  },
    {
    id: 29,
    title: 'Paycheck Fairness Act',
    date: '2010-11-17',
    href: 'https://justfacts.votesmart.org/bill/votes/32830',
    desc: 'Vote on a motion to invoke cloture on a bill that prohibits workplace discrimination based on gender and authorizes studies on discrimination.',
    bill: 'S. 3772',
    congress: 111,
    votes: {
      demPro: 56,
      demCon: 1,
      repPro: 0,
      repCon: 40
    },
    backgroundLinks: [
      { title: 'govtrack.us', href: 'https://www.govtrack.us/congress/bills/111/s3772' },
      { title: 'congress.gov', href: 'https://www.congress.gov/bill/111th-congress/senate-bill/3772?q=%7B%22search%22%3A%5B%22S+3772+-+Paycheck+Fairness+Act%22%2C%22S%22%2C%223772%22%2C%22Paycheck%22%2C%22Fairness%22%2C%22Act%22%5D%7D&s=10&r=1' }
    ],
    tags: [ 'paycheck', 'discrimination', 'jobs', 'gender', 'sexism' ]
  },
    {
    id: 30,
    title: 'Time Between Troop Deployments',
    date: '2007-9-19',
    href: 'https://justfacts.votesmart.org/bill/votes/15831',
    desc: 'Vote to adopt an amendment that adds language to HR 1585 establishing mandatory minimum rest periods for members of the regular and reserve components of the armed forces between deployments to Iraq and Afghanistan, and expressing the sense of the Congress concerning ideal rest periods between these deployments.',
    bill: 'S. Amdt. 2909',
    congress: 110,
    votes: {
      demPro: 49,
      demCon: 1,
      repPro: 6,
      repCon: 42
    },
    backgroundLinks: [
      { title: 'sgp.fas.org', href: 'https://sgp.fas.org/crs/natsec/R40682.pdf' },
      { title: 'congress.gov', href: 'https://www.congress.gov/amendment/110th-congress/senate-amendment/2909?q=%7B%22search%22%3A%5B%22R.%22%5D%7D&s=1&r=40' }
    ],
    tags: [ 'troop deployments', 'military' ]
  },
    {
    id: 31,
    title: 'Habeas Corpus for Detainees of the United States',
    date: '2007-9-19',
    href: 'https://justfacts.votesmart.org/bill/votes/15833',
    desc: 'Vote to invoke cloture on an amendment that would reapply the habeas corpus requirement to persons being detained by the United States.',
    bill: 'S. Amdt. 2022',
    congress: 110,
    votes: {
      demPro: 50,
      demCon: 0,
      repPro: 5,
      repCon: 42
    },
    backgroundLinks: [
      { title: 'npr.org', href: 'https://www.npr.org/2007/06/29/11600605/primer-guantanamo-detainees-rights' },
      { title: 'congress.gov', href: 'https://www.congress.gov/amendment/110th-congress/senate-amendment/2022' }
    ],
    tags: [ 'habeas corpus', 'detention', 'military']
  },
    {
    id: 32,
    title: 'Habeas Review Amendment',
    date: '2006-9-28',
    href: 'https://justfacts.votesmart.org/bill/votes/8730',
    desc: 'Vote to adopt an amendment that strikes language in the bill that prevents any court, justice, or judge from hearing or considering a writ of habeas corpus and certain other actions against the U.S. by an individual detained by the U.S. military.',
    bill: 'S. Amdt. 5087',
    congress: 109,
    votes: {
      demPro: 43,
      demCon: 1,
      repPro: 3,
      repCon: 50
    },
    backgroundLinks: [
      { title: 'aclu.org', href: 'https://www.aclu.org/other/background-habeas-corpus' },
      { title: 'congress.gov', href: 'https://www.congress.gov/amendment/109th-congress/senate-amendment/5087' }
    ],
    tags: [ 'habeas corpus', 'detention', 'military' ]
  },
    {
    id: 33,
    title: 'Prohibits Detention of U.S. Citizens Without Trial',
    date: '2011-12-1',
    href: 'https://justfacts.votesmart.org/bill/votes/37420',
    desc: 'Vote to adopt an amendment to S 1867 that prohibits the Armed Forces of the United States from detaining a United States citizen without trial during wartime.',
    bill: 'S. Amdt. 1126',
    congress: 112,
    votes: {
      demPro: 39,
      demCon: 12,
      repPro: 5,
      repCon: 42
    },
    backgroundLinks: [
      { title: 'aclu.org', href: 'https://www.aclu.org/issues/national-security/detention/indefinite-detention-endless-worldwide-war-and-2012-national' },
      { title: 'congress.gov', href: 'https://www.congress.gov/amendment/112th-congress/senate-amendment/1126' }
    ],
    tags: [ 'detention', 'trial', 'military', 'wartime', 'civil rights' ]
  },
    {
    id: 34,
    title: 'Authorizes Further Detention After Trial During Wartime',
    date: '2011-12-1',
    href: 'https://justfacts.votesmart.org/bill/votes/37433',
    desc: 'Vote to adopt an amendment to S 1867 that authorizes further detention by the military of an individual under the "laws of war," even if the individual has received a trial or has been transferred for trial by an alternative court.',
    bill: 'S. Amdt. 1274',
    congress: 112,
    votes: {
      demPro: 2,
      demCon: 49,
      repPro: 38,
      repCon: 9
    },
    backgroundLinks: [
      { title: 'aclu.org', href: 'https://www.aclu.org/other/indefinite-detention' },
      { title: 'congress.gov', href: 'https://www.congress.gov/amendment/112th-congress/senate-amendment/1274' }
    ],
    tags: [ 'detention', 'trial', 'military', 'wartime' ]
  },
    {
    id: 35,
    title: 'Prohibits the Use of Funds for Prosecution of Enemy Combatants in Civilian Courts',
    date: '2011-10-21',
    href: 'https://justfacts.votesmart.org/bill/votes/37095',
    desc: 'Vote to adopt an amendment to S Amdt 738 to HR 2112 that prohibits federal funding from being used to prosecute certain individuals in United States courts.',
    bill: 'S. Amdt. 753',
    congress: 112,
    votes: {
      demPro: 1,
      demCon: 49,
      repPro: 45,
      repCon: 2
    },
    backgroundLinks: [
      { title: 'congress.gov', href: 'https://www.congress.gov/amendment/112th-congress/senate-amendment/753' }
    ],
    tags: [ 'funding', 'prosecution', 'military' ]
  },
    {
    id: 36,
    title: 'Repeals Indefinite Military Detention Provisions',
    date: '2014-5-22',
    href: 'https://justfacts.votesmart.org/bill/votes/48229',
    desc: 'Vote to adopt an amendment to HR 4435 that requires certain individuals to be transferred for a trial and proceedings by court immediately upon coming into custody of the federal government.',
    bill: 'H. Amdt. 676',
    congress: 113,
    votes: {
      demPro: 176,
      demCon: 16,
      repPro: 15,
      repCon: 214
    },
    backgroundLinks: [
      { title: 'congress.gov', href: 'https://www.congress.gov/amendment/113th-congress/house-amendment/676' }
    ],
    tags: [ 'detention', 'military' ]
  },
    {
    id: 37,
    title: 'Oversight of CIA Interrogation and Detention Amendment',
    date: '2006-9-28',
    href: 'https://justfacts.votesmart.org/bill/votes/8795',
    desc: 'Vote to adopt an amendment that requires the Director of the CIA and others to report to the congressional intelligence committees every three months on the detention, interrogation and rendition programs.',
    bill: 'S. Amdt. 5095',
    congress: 109,
    votes: {
      demPro: 43,
      demCon: 1,
      repPro: 1,
      repCon: 52
    },
    backgroundLinks: [
      { title: 'congress.gov', href: 'https://www.congress.gov/amendment/109th-congress/senate-amendment/5095' }
    ],
    tags: [ 'CIA', 'detention', 'interrogation', 'intelligence' ]
  },
    {
    id: 38,
    title: 'PATRIOT Act Extension',
    date: '2011-5-26',
    href: 'https://justfacts.votesmart.org/bill/votes/35224',
    desc: 'Vote to concur with Senate amendments and pass a bill that extends the expiration date of the USA PATRIOT Act from May 27, 2011, to June 1, 2015.',
    bill: 'S. 990',
    congress: 112,
    votes: {
      demPro: 54,
      demCon: 122,
      repPro: 196,
      repCon: 31
    },
    backgroundLinks: [
      { title: 'congress.gov', href: 'https://www.congress.gov/bill/112th-congress/senate-bill/990?q=%7B%22search%22%3A%5B%22PATRIOT+Act+Extension%22%2C%22PATRIOT%22%2C%22Act%22%2C%22Extension%22%5D%7D&s=3&r=5' },
      { title: 'govtrack.us', href: 'https://www.govtrack.us/congress/bills/112/s990' }
    ],
    tags: [ 'PATRIOT Act', 'security', 'homeland security' ]
  },
    {
    id: 39,
    title: 'FISA Amendments Act',
    date: '2008-6-20',
    href: 'https://clerk.house.gov/evs/2008/roll437.xml',
    desc: 'Amends the Foreign Intelligence Surveillance Act of 1978 (FISA) to add a new title concerning additional procedures for acquiring the communications of certain persons outside the United States.',
    bill: 'H.R. 6304',
    congress: 110,
    votes: {
      demPro: 105,
      demCon: 128,
      repPro: 188,
      repCon: 1
    },
    backgroundLinks: [
      { title: 'govtrack.us', href: 'https://www.govtrack.us/congress/bills/110/hr6304' },
      { title: 'congress.gov', href: 'https://www.congress.gov/bill/110th-congress/house-bill/6304?q=%7B%22search%22%3A%5B%22FISA+Amendments+Act%22%2C%22FISA%22%2C%22Amendments%22%2C%22Act%22%5D%7D&s=5&r=4' }
    ],
    tags: [ 'FISA', 'communications', 'intelligence' ]
  },
    {
    id: 40,
    title: 'FISA Amendments Act Reauthorization Act',
    date: '2012-9-12',
    href: 'https://www.govtrack.us/congress/votes/112-2012/h569',
    desc: 'Amends the FISA Amendments Act of 2008 to extend until December 31, 2017',
    bill: 'H.R. 5949',
    congress: 112,
    votes: {
      demPro: 74,
      demCon: 111,
      repPro: 227,
      repCon: 7
    },
    backgroundLinks: [
      { title: 'congress.gov', href: 'https://www.congress.gov/bill/112th-congress/house-bill/5949?q=%7B%22search%22%3A%5B%22H.R.+5949+%28112th%29%3A+FISA+Amendments+Act+Reauthorization+Act+of+2012%22%2C%22H.R.%22%2C%225949%22%2C%22%28112th%29%3A%22%2C%22FISA%22%2C%22Amendments%22%2C%22Act%22%2C%22Reauthorization%22%2C%22of%22%2C%222012%22%5D%7D&s=6&r=1' },
    ],
    tags: [ 'FISA', 'reauthorization', 'intellignence' ]
  },
    {
    id: 41,
    title: 'National Defense Authorization Act',
    date: '2013-6-14',
    href: 'https://www.congress.gov/bill/113th-congress/house-bill/1960',
    desc: 'Authorizes appropriations for FY2014 for the Department of Defense (DOD) for procurement for the Army, Navy and Marine Corps, Air Force, and defense-wide activities.',
    bill: 'H.R. 1960',
    congress: 113,
    votes: {
      demPro: 172,
      demCon: 21,
      repPro: 2,
      repCon: 228
    },
    backgroundLinks: [
      { title: 'clerk.house.gov', href: 'https://clerk.house.gov/evs/2013/roll237.xml' }
    ],
    tags: [ 'military', 'defense', 'funding', 'Department of Defense' ]
  },
  {
    id: 42,
    title: 'Prohibits the Use of Funds for the Transfer or Release of Guantanamo Detainees',
    date: '2013-11-19',
    href: 'https://justfacts.votesmart.org/bill/votes/46301',
    desc: 'Vote to adopt an amendment to S. 1197 that prohibits the Department of Defense from using funds for the transfer or the release of individuals detained at Guantanamo Bay.',
    bill: 'S. Amdt. 2255',
    congress: 113,
    votes: {
      demPro: 3,
      demCon: 50,
      repPro: 40,
      repCon: 3
    },
    backgroundLinks: [
      { title: 'nytimes.com', href: 'https://www.nytimes.com/2021/10/13/us/politics/guantanamo-detainees-transfer.html' },
      { title: 'congress.gov', href: 'https://www.congress.gov/amendment/113th-congress/senate-amendment/2255' }
    ],
    tags: [ 'Department of Defense', 'Guantanamo Bay', 'security', 'homeland security' ]
  },
    {
    id: 43,
    title: 'Prohibits the Use of Funds for the Transfer or Release of Individuals Detained at Guantanamo Bay',
    date: '2012-11-29',
    href: 'https://justfacts.votesmart.org/bill/votes/42002',
    desc: 'Vote to adopt an amendment to S. 3254 that prohibits the transfer of detainees from Guantanamo Bay to the United States.',
    bill: 'S. Amdt. 3245',
    congress: 112,
    votes: {
      demPro: 9,
      demCon: 40,
      repPro: 44,
      repCon: 0
    },
    backgroundLinks: [
      { title: 'cnn.com', href: 'https://www.cnn.com/2016/08/17/politics/what-to-know-about-guantanamo-bay' },
      { title: 'congress.gov', href: 'https://www.congress.gov/amendment/112th-congress/senate-amendment/3245' }
    ],
    tags: [ 'Guantanamo Bay', 'funding', 'security', 'homeland security' ]
  },
    {
    id: 44,
    title: 'Oversight of CIA Interrogation and Detention Amendment',
    date: '2006-9-28',
    href: 'https://justfacts.votesmart.org/bill/votes/8795',
    desc: 'Vote to adopt an amendment that requires the Director of the CIA and others to report to the congressional intelligence committees every three months on the detention, interrogation and rendition programs.',
    bill: 'S. Amdt. 5095',
    congress: 109,
    votes: {
      demPro: 43,
      demCon: 1,
      repPro: 1,
      repCon: 52
    },
    backgroundLinks: [
      { title: 'cnn.com', href: 'https://www.cnn.com/2014/12/09/politics/top-takeaways-cia-torture-report' },
      { title: 'congress.gov', href: 'https://www.congress.gov/amendment/109th-congress/senate-amendment/5095' }
    ],
    tags: [ 'CIA', 'interrogation', 'detention' ]
  },
  {
    id: 45,
    title: 'Marriage Protection Amendment',
    date: '2006-6-7',
    href: 'https://justfacts.votesmart.org/bill/votes/11729',
    desc: 'Vote on the motion to invoke cloture on a joint resolution proposing a constitutional amendment defining marriage as consisting of a man and a woman.',
    bill: 'S. J. Res. 1',
    congress: 109,
    votes: {
      demPro: 2,
      demCon: 40,
      repPro: 47,
      repCon: 6
    },
    backgroundLinks: [
      { title: 'congress.gov', href: 'https://www.congress.gov/bill/109th-congress/senate-joint-resolution/1?q=%7B%22search%22%3A%5B%22Same+Sex+Marriage+Resolution%22%2C%22Same%22%2C%22Sex%22%2C%22Marriage%22%2C%22Resolution%22%5D%7D&s=3&r=1' },
      { title: 'govtrack.us', href: 'https://www.govtrack.us/congress/bills/109/sjres1'}
    ],
    tags: [ 'marriage', 'same sex marriage', 'LGBTQ+']
  },
    {
    id: 46,
    title: 'Employment Non-Discrimination Act',
    date: '2013-11-7',
    href: 'https://justfacts.votesmart.org/bill/votes/46286',
    desc: 'Vote to pass a bill that prohibits employment discrimination based on the real or perceived sexual orientation or gender identity of an individual.',
    bill: 'S. 815',
    congress: 113,
    votes: {
      demPro: 52,
      demCon: 0,
      repPro: 10,
      repCon: 32
    },
    backgroundLinks: [
      { title: 'govtrack.us', href: 'https://www.govtrack.us/congress/bills/113/s815' },
      { title: 'congress.gov', href: 'https://www.congress.gov/bill/113th-congress/senate-bill/815?q=%7B%22search%22%3A%5B%22S.+815+%28113th%29%3A+Employment+Non-Discrimination+Act+of+2013%22%2C%22S.%22%2C%22815%22%2C%22%28113th%29%3A%22%2C%22Employment%22%2C%22Non-Discrimination%22%2C%22Act%22%2C%22of%22%2C%222013%22%5D%7D&s=5&r=1' }
    ],
    tags: [ 'employment', 'jobs', 'discrimination', 'LGBTQ+' ]
  },
    {
    id: 47,
    title: 'Exempts Religiously Affiliated Employers from the Prohibition on Employment Discrimination Based on Sexual Orientation and Gender Identity',
    date: '2013-12-7',
    href: 'https://justfacts.votesmart.org/bill/votes/46288',
    desc: 'Vote to adopt an amendment to S Amdt 2012 to S 815 that exempts religiously-affiliated employers from the prohibition on employment discrimination on the basis of sexual orientation or gender identity.',
    bill: 'S. Amdt. 2013',
    congress: 113,
    votes: {
      demPro: 2,
      demCon: 50,
      repPro: 41,
      repCon: 3
    },
    backgroundLinks: [
      { title: 'nytimes.com', href: 'https://www.nytimes.com/2020/06/15/us/gay-transgender-workers-supreme-court.html' },
      { title: 'congress.gov', href: 'https://www.congress.gov/amendment/113th-congress/senate-amendment/720' }
    ],
    tags: [ 'employment', 'jobs', 'discrimination', 'LGBTQ+' ]
  },
    {
    id: 48,
    title: 'Teen Pregnancy Education Amendment',
    date: '2006-7-25',
    href: 'https://justfacts.votesmart.org/bill/votes/8830',
    desc: 'Vote to adopt an amendment that authorizes grants from 2007 to 2011 for sexual education programs dealing with contraceptives and abstinence for the "prevention of teen pregnancy and sexual transmitted diseases."',
    bill: 'S. Amdt. 4689',
    congress: 109,
    votes: {
      demPro: 42,
      demCon: 1,
      repPro: 4,
      repCon: 50
    },
    backgroundLinks: [
      { title: 'healthyteennetwork.org', href: 'https://www.healthyteennetwork.org/resources/position-statement-educational-equity-young-people-pregnant-parenting/' },
      { title: 'congress.gov', href: 'https://www.congress.gov/amendment/109th-congress/senate-amendment/4689' }
    ],
    tags: [ 'pregnancy', 'sexual education', ]
  },
    {
    id: 49,
    title: 'Unintended Pregnancy Amendment',
    date: '2005-3-17',
    href: 'https://justfacts.votesmart.org/bill/votes/20713',
    desc: 'Vote to adopt an amendment to the Senates 2006 Fiscal Year Budget that allocates $100 million for the prevention of unintended pregnancies.',
    bill: 'S. Amdt. 244',
    congress: 109,
    votes: {
      demPro: 42,
      demCon: 2,
      repPro: 3,
      repCon: 51
    },
    backgroundLinks: [
      { title: 'brookings.edu', href: 'https://www.brookings.edu/research/preventing-unplanned-pregnancy-lessons-from-the-states/' },
      { title: 'congress.gov', href: 'https://www.congress.gov/amendment/109th-congress/senate-amendment/244' }
    ],
    tags: [ 'pregnancy', 'teen pregnancy', 'sexual education', 'family planning' ]
  },
    {
    id: 50,
    title: 'Protect Womens Health From Corporate Interference Act',
    date: '2014-7-16',
    href: 'https://justfacts.votesmart.org/bill/votes/49362',
    desc: 'Vote on a motion to invoke cloture on a motion to proceed to debate on a bill that prohibits any employer that maintains a group health plan for its employees from denying coverage of any health care item or service required under federal law.',
    bill: 'S. 2578',
    congress: 113,
    votes: {
      demPro: 51,
      demCon: 1,
      repPro: 3,
      repCon: 42
    },
    backgroundLinks: [
      { title: 'govtrack.us', href: 'https://www.govtrack.us/congress/bills/113/s2578' },
      { title: 'congress.gov', href: 'https://www.congress.gov/bill/113th-congress/senate-bill/2578?q=%7B%22search%22%3A%5B%22Protect+Womens+Health+From+Corporate+Interference+Act%22%2C%22Protect%22%2C%22Womens%22%2C%22Health%22%2C%22From%22%2C%22Corporate%22%2C%22Interference%22%2C%22Act%22%5D%7D&s=9&r=2' }
    ],
    tags: [ 'womens health', 'corporations', 'health care' ]
  },
    {
    id: 51,
    title: 'Stop the War on Coal Act',
    date: '2012-9-21',
    href: 'https://justfacts.votesmart.org/bill/votes/41688',
    desc: 'Vote to pass a bill that prohibits the Environmental Protection Agency from enforcing certain regulations.',
    bill: 'H.R. 3409',
    congress: 112,
    votes: {
      demPro: 19,
      demCon: 162,
      repPro: 214,
      repCon: 13
    },
    backgroundLinks: [
      { title: 'govtrack.us', href: 'https://www.govtrack.us/congress/bills/112/hr3409' },
      { title: 'congress.gov', href: 'https://www.congress.gov/bill/112th-congress/house-bill/3409?q=%7B%22search%22%3A%5B%22HR+3409+-+Stop+the+War+on+Coal+Act+of+2012%22%2C%22HR%22%2C%223409%22%2C%22Stop%22%2C%22the%22%2C%22War%22%2C%22on%22%2C%22Coal%22%2C%22Act%22%2C%22of%22%2C%222012%22%5D%7D&s=2&r=1' }
    ],
    tags: [ 'coal', 'energy', 'fossil fuels', 'environment', 'Environmental Protection Agency', 'EPA' ]
  },
    {
    id: 52,
    title: 'EPA Science Advisory Board Reform Act',
    date: '2014-11-18',
    href: 'https://justfacts.votesmart.org/bill/votes/50594',
    desc: 'Vote to pass a bill that amends membership requirements and responsibilities of the Environmental Protection Agencys (EPA) Science Advisory Board.',
    bill: 'H.R. 1422',
    congress: 113,
    votes: {
      demPro: 4,
      demCon: 190,
      repPro: 225,
      repCon: 1
    },
    backgroundLinks: [
      { title: 'govtrack.us', href: 'https://www.govtrack.us/congress/bills/113/hr1422' },
      { title: 'congress.gov', href: 'https://www.congress.gov/bill/113th-congress/house-bill/1422?q=%7B%22search%22%3A%5B%22HR+1422+-+EPA+Science+Advisory+Board+Reform+Act%22%2C%22HR%22%2C%221422%22%2C%22EPA%22%2C%22Science%22%2C%22Advisory%22%2C%22Board%22%2C%22Reform%22%2C%22Act%22%5D%7D&s=3&r=1' }
    ],
    tags: [ 'Environmental Protection Agency', 'environment', 'EPA', 'Science Advisory Board' ]
  },
    {
    id: 53,
    title: 'Prohibits the Social Cost of Carbon from Being Included in Agency Determinations',
    date: '2014-3-6',
    href: 'https://justfacts.votesmart.org/bill/votes/46997',
    desc: 'Vote to adopt an amendment to HR 2641 that prohibits the social cost of carbon from being used in an environmental review or decision-making process of a regulatory agency.',
    bill: 'H. Amdt. 585',
    congress: 113,
    votes: {
      demPro: 4,
      demCon: 186,
      repPro: 218,
      repCon: 2
    },
    backgroundLinks: [
      { title: 'rff.org', href: 'https://www.rff.org/publications/explainers/social-cost-carbon-101/' },
      { title: 'congress.gov', href: 'https://www.congress.gov/amendment/113th-congress/house-amendment/585/all-info' }
    ],
    tags: [ 'carbon', 'environment', 'cost of carbon' ]
  },
    {
    id: 54,
    title: 'To Prohibit the Use of Funds to Carry Out the Patient Protection and Affordable Care Act',
    date: '2013-3-13',
    href: 'https://justfacts.votesmart.org/bill/votes/43144',
    desc: 'Vote to adopt an amendment to S Amdt 26 to HR 933 that prohibits the use of funds from this act to implement the Patient Protection and Affordable Care Act.',
    bill: 'S. Amdt. 30',
    congress: 113,
    votes: {
      demPro: 0,
      demCon: 50,
      repPro: 45,
      repCon: 0
    },
    backgroundLinks: [
      { title: 'nih.gov', href: 'https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3001814/' },
      { title: 'congress.gov', href: 'https://www.congress.gov/amendment/113th-congress/senate-amendment/30' }
    ],
    tags: [ 'funding', 'affordable care', 'health care', 'patient protection' ]
  },
    {
    id: 55,
    title: 'Prohibiting Federal Funding of National Public Radio',
    date: '2011-3-17',
    href: 'https://justfacts.votesmart.org/bill/votes/34089',
    desc: 'Vote to pass a bill that prohibits federal funding of National Public Radio and the use of federal funds to acquire radio content.',
    bill: 'H.R. 1076',
    congress: 112,
    votes: {
      demPro: 0,
      demCon: 185,
      repPro: 228,
      repCon: 7
    },
    backgroundLinks: [
      { title: 'govtrack.us', href: 'https://www.govtrack.us/congress/bills/112/hr1076' },
      { title: 'congress.gov', href: 'https://www.congress.gov/bill/112th-congress/house-bill/1076?q=%7B%22search%22%3A%5B%22HR+1076+-+Prohibiting+Federal+Funding+of+National+Public+Radio%22%2C%22HR%22%2C%221076%22%2C%22Prohibiting%22%2C%22Federal%22%2C%22Funding%22%2C%22of%22%2C%22National%22%2C%22Public%22%2C%22Radio%22%5D%7D&s=6&r=1' }
    ],
    tags: [ 'funding', 'national public radio', 'radio' ]
  },
    {
    id: 56,
    title: 'Preserving Employee Wellness Programs Act',
    date: '2017-',
    href: 'https://www.congress.gov/bill/115th-congress/house-bill/1313?q=%7B%22search%22%3A%5B%22H.R.1313+115th%22%2C%22H.R.1313%22%2C%22115th%22%5D%7D&s=2&r=1',
    desc: 'This bill exempts workplace wellness programs from: (1) limitations under the Americans with Disabilities Act of 1990 on medical examinations and inquiries of employees, (2) the prohibition on collecting genetic information in connection with issuing health insurance, and (3) limitations under the Genetic Information Nondiscrimination Act of 2008 on collecting the genetic information of employees or family members of employees. This exemption applies to workplace wellness programs that comply with limits on rewards for employees participating in the program.',
    bill: 'H.R.1313',
    congress: 115,
    votes: {
      demPro: 0,
      demCon: 17,
      repPro: 22,
      repCon: 0
    },
    backgroundLinks: [
      { title: 'www.govtrack.us', href: 'https://www.govtrack.us/congress/bills/115/hr1313' },
      { title: 'washingtonpost.com', href: 'https://www.washingtonpost.com/news/to-your-health/wp/2017/03/11/employees-who-decline-genetic-testing-could-face-penalities-under-proposed-bill/' }
    ],
    tags: [ 'employee wellness programs', 'wellness programs', 'health insurance', 'employees', 'jobs' ]
  }



  /*
  {
    id: ,
    title: '',
    date: '',
    href: '',
    desc: '',
    bill: '',
    congress: ,
    votes: {
      demPro: ,
      demCon: ,
      repPro: ,
      repCon: 
    },
    backgroundLinks: [
      { title: '', href: '' }
    ],
    tags: [ '' ]
  }
  */
]


